import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';

const _handleOnChange = (onPageScroll) => (isVisible) => {
    if (isVisible) {
        onPageScroll();
    }
};

const PaginationLoader = ({ onPageScroll }) => (
    <VisibilitySensor onChange={_handleOnChange(onPageScroll)}>
        <div className="eds-align--center eds-l-pad-top-8">
            <ProgressIndicator
                style="gradient"
                size="small-chunky"
                shape="circular"
            />
        </div>
    </VisibilitySensor>
);

export default PaginationLoader;
